<template>
  <div id="forbidden-view">
    <h1>{{ $t('forbiddenView.heading') }}</h1>
    <p>
      {{ $t('forbiddenView.subheading') }}
    </p>
  </div>
</template>

<script src="./ForbiddenView.script.ts" lang="ts"></script>
<style src="./ForbiddenView.style.scss" lang="scss" scoped></style>
